module.exports = __webpack_public_path__ + "img/wd.bb881a36.png";